var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Vue from "vue";
import gql from "graphql-tag";
import SmallBlogPostCard from "../general/SmallBlogPostCard.vue";
import ReviewsSection from "../../ui/ReviewsSection.vue";
import SmallBlogPostsSection from "../../ui/SmallBlogPostsSection.vue";
import MainDetailIcons from "./MainDetailIcons.vue";
import AreaMap from "./map/AreaMap.vue";
import StaticAreaMap from "./map/StaticAreaMap.vue";
import { createMetaDescription } from "../../../utils/meta";
import SaveButton from "./SaveButton.vue";
import SimilarProperties from "./SimilarProperties.vue";
import ListingMedia from "./ListingMedia.vue";
import ListingLoader from "./ListingLoader.vue";
import ListingRoomTypes from "./ListingRoomTypes.vue";
import flatMap from "lodash/flatMap";
import maxBy from "lodash/maxBy";
import { getPropertyListingPrice, } from "../../../features/accommodation";
import RoomTypeCard from "./RoomTypeCard.vue";
import { lastOrThrow } from "../../../utils/array";
export default Vue.extend({
    components: {
        ListingLoader: ListingLoader,
        SmallBlogPostsSection: SmallBlogPostsSection,
        ReviewsSection: ReviewsSection,
        MainDetailIcons: MainDetailIcons,
        AreaMap: AreaMap,
        StaticAreaMap: StaticAreaMap,
        SimilarProperties: SimilarProperties,
        SaveButton: SaveButton,
        ListingMedia: ListingMedia,
        ListingRoomTypes: ListingRoomTypes,
    },
    data: function () {
        return {
            windowScrollY: 0,
            textSectionStates: {},
        };
    },
    computed: {
        allLeaseTerms: function () {
            if (!this.publishedPropertyBySlug) {
                return [];
            }
            return flatMap(this.publishedPropertyBySlug.roomTypes.map(function (r) { return r.leaseTerms; }));
        },
        haveMultipleLeaseTerms: function () {
            return this.allLeaseTerms.length > 1;
        },
        onlyLeaseTerm: function () {
            if (this.allLeaseTerms.length === 1) {
                return this.allLeaseTerms[0];
            }
            return undefined;
        },
        price: function () {
            if (!this.publishedPropertyBySlug) {
                return undefined;
            }
            return getPropertyListingPrice(this.publishedPropertyBySlug);
        },
        iconSections: function () {
            if (!this.publishedPropertyBySlug) {
                return [];
            }
            return [
                {
                    title: this.$t("Facilities").toString(),
                    other: this.publishedPropertyBySlug.facilitiesOther,
                    icons: this.publishedPropertyBySlug.facilitiesIcons,
                },
                {
                    title: this.$t("Safety").toString(),
                    other: this.publishedPropertyBySlug.safetyOther,
                    icons: this.publishedPropertyBySlug.safetyIcons,
                },
                {
                    title: this.$t("Bill inclusions").toString(),
                    other: this.publishedPropertyBySlug.billInclusionsOther,
                    icons: this.publishedPropertyBySlug.billInclusionsIcons,
                },
                {
                    title: this.$t("Points of interest").toString(),
                    other: this.publishedPropertyBySlug.pointsOfInterestOther,
                    icons: this.publishedPropertyBySlug.pointsOfInterestIcons,
                },
            ].filter(function (s) { return s.icons.length > 0 || !!s.other; });
        },
        breadcrumbItems: function () {
            if (!this.publishedPropertyBySlug) {
                return [];
            }
            var root = { name: this.$t("Accommodation"), link: "/accommodation" };
            var leaf = { name: this.publishedPropertyBySlug.streetAddress };
            if (this.institutionBySlug) {
                return [
                    root,
                    {
                        name: this.institutionBySlug.cityName,
                        link: "/accommodation/".concat(this.institutionBySlug.citySlug),
                    },
                    {
                        name: this.institutionBySlug.name,
                        link: "/accommodation/".concat(this.institutionBySlug.citySlug, "/").concat(this.institutionBySlug.slug),
                    },
                    leaf,
                ];
            }
            return [
                root,
                {
                    name: this.publishedPropertyBySlug.suburbName,
                    link: "/accommodation/".concat(this.publishedPropertyBySlug.citySlug),
                },
                leaf,
            ];
        },
        areTabsStuck: function () {
            var _a;
            return ((_a = this.$refs.listingSectionTabs) === null || _a === void 0 ? void 0 : _a.offsetTop) === this.windowScrollY;
        },
        tabsNavHeight: function () {
            var tabs = this.$refs.listingSectionTabs;
            if (!tabs) {
                return 0;
            }
            return tabs.getBoundingClientRect().height;
        },
        scrolledSection: function () {
            var _this = this;
            var _a;
            // NOTE: Only needed to trigger recalculation. Probably a more vueish qay to do this
            if (!this.windowScrollY) {
                return "overview";
            }
            var sectionRefs = __spreadArray([
                {
                    section: "map",
                    ref: this.$refs.mapSection,
                },
                {
                    section: "reviews",
                    ref: this.$refs.reviewsSection,
                },
                {
                    section: "rooms",
                    ref: this.$refs.roomsSection,
                },
                {
                    section: "facilities",
                    ref: this.$refs.facilitiesSection,
                }
            ], (((_a = this.publishedPropertyBySlug) === null || _a === void 0 ? void 0 : _a.textSections) || []).map(function (t) { return ({
                section: _this.getTextSectionAnchor(t),
                ref: _this.$refs[_this.getTextSectionAnchor(t) + "Ref"][0],
            }); }), true);
            var past = sectionRefs.filter(function (d) { var _a, _b; return ((_b = (_a = d.ref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top) <= _this.tabsNavHeight; });
            if (past.length === 0) {
                return "overview";
            }
            return maxBy(past, function (p) { var _a, _b; return (_b = (_a = p.ref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top; }).section;
        },
    },
    apollo: {
        publishedPropertyBySlug: {
            query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query ListingQuery($slug: String!) {\n          publishedPropertyBySlug(slug: $slug) {\n            id\n            slug\n            propertyName\n            fullAddress\n            streetAddress\n            ...MainDetailIcons_property\n            isFurnished\n            isLeased\n            suburbName\n            citySlug\n            metaTitle\n            metaDescription\n            description\n            reviews {\n              person\n              content\n            }\n            latLong {\n              lat\n              long\n            }\n            photos {\n              id\n              thumbnailUrl\n              mediumUrl\n              largeUrl\n              largeBannerUrl\n            }\n            videos {\n              id\n              thumbnailUrl\n              mediumUrl\n              largeBannerUrl\n              iFrameEmbedUrl\n            }\n            cityTaggedBlogPosts(amount: 4) {\n              id\n              ...SmallBlogPostCard_post\n            }\n            highlightText\n            safetyOther\n            safetyIcons {\n              name\n              imageUrl\n            }\n            facilitiesOther\n            facilitiesIcons {\n              name\n              imageUrl\n            }\n            billInclusionsOther\n            billInclusionsIcons {\n              name\n              imageUrl\n            }\n            pointsOfInterestOther\n            pointsOfInterestIcons {\n              name\n              text\n              imageUrl\n            }\n            textSections {\n              id\n              title\n              content\n            }\n            roomTypes {\n              ...RoomTypeCard_roomType\n              leaseTerms {\n                id\n              }\n            }\n            ...SaveButton_property\n            ...AreaMap_property\n            ...SimilarProperties_property\n          }\n        }\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      "], ["\n        query ListingQuery($slug: String!) {\n          publishedPropertyBySlug(slug: $slug) {\n            id\n            slug\n            propertyName\n            fullAddress\n            streetAddress\n            ...MainDetailIcons_property\n            isFurnished\n            isLeased\n            suburbName\n            citySlug\n            metaTitle\n            metaDescription\n            description\n            reviews {\n              person\n              content\n            }\n            latLong {\n              lat\n              long\n            }\n            photos {\n              id\n              thumbnailUrl\n              mediumUrl\n              largeUrl\n              largeBannerUrl\n            }\n            videos {\n              id\n              thumbnailUrl\n              mediumUrl\n              largeBannerUrl\n              iFrameEmbedUrl\n            }\n            cityTaggedBlogPosts(amount: 4) {\n              id\n              ...SmallBlogPostCard_post\n            }\n            highlightText\n            safetyOther\n            safetyIcons {\n              name\n              imageUrl\n            }\n            facilitiesOther\n            facilitiesIcons {\n              name\n              imageUrl\n            }\n            billInclusionsOther\n            billInclusionsIcons {\n              name\n              imageUrl\n            }\n            pointsOfInterestOther\n            pointsOfInterestIcons {\n              name\n              text\n              imageUrl\n            }\n            textSections {\n              id\n              title\n              content\n            }\n            roomTypes {\n              ...RoomTypeCard_roomType\n              leaseTerms {\n                id\n              }\n            }\n            ...SaveButton_property\n            ...AreaMap_property\n            ...SimilarProperties_property\n          }\n        }\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      "])), MainDetailIcons.options.fragments.property, AreaMap.options.fragments.property, SmallBlogPostCard.options.fragments.post, SaveButton.options.fragments.property, SimilarProperties.options.fragments.property, RoomTypeCard.options.fragments.roomType),
            variables: function () {
                return {
                    slug: this.$route.params.slug,
                };
            },
        },
        institutionBySlug: {
            query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        query ListingInstitutionQuery($slug: String!) {\n          institutionBySlug(slug: $slug) {\n            slug\n            name\n            citySlug\n            cityName\n          }\n        }\n      "], ["\n        query ListingInstitutionQuery($slug: String!) {\n          institutionBySlug(slug: $slug) {\n            slug\n            name\n            citySlug\n            cityName\n          }\n        }\n      "]))),
            variables: function () {
                return { slug: this.$route.query.institution };
            },
            skip: function () {
                return !this.$route.query.institution;
            },
        },
    },
    mounted: function () {
        window.addEventListener("scroll", this.onScrollUpdate);
        window.addEventListener("resize", this.onScrollUpdate);
        this.onScrollUpdate();
    },
    beforeDestroy: function () {
        window.removeEventListener("scroll", this.onScrollUpdate);
        window.removeEventListener("resize", this.onScrollUpdate);
    },
    methods: {
        onToggleTextSection: function (section, toggled) {
            if (typeof document === "undefined") {
                return;
            }
            var previous = this.textSectionStates[section.id];
            this.textSectionStates[section.id] = toggled;
            if (previous === undefined) {
                return;
            }
            if (!toggled) {
                var sectionName = this.getTextSectionAnchor(section);
                var sectionElement = document.getElementsByName(sectionName)[0];
                if (!sectionElement) {
                    return;
                }
                this.scrollToSection(sectionElement);
            }
        },
        getTextSectionAnchor: function (textSection) {
            return "text-section-" + textSection.id;
        },
        onScrollUpdate: function () {
            var windowY = window.top.scrollY;
            if (windowY === undefined) {
                // For IE, possibly other older browsers too
                this.windowScrollY = document.documentElement.scrollTop;
            }
            else {
                this.windowScrollY = window.top.scrollY;
            }
        },
        scrollToSection: function (section) {
            // A small offset to ensure tab becomes active
            var scrolledTop = section.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: scrolledTop - this.tabsNavHeight + 2,
                behavior: "smooth",
            });
        },
        onPageSectionLinkClick: function (e) {
            var sectionName = lastOrThrow(e.currentTarget.href.split("#"));
            var section = document.getElementsByName(sectionName)[0];
            if (!section) {
                return;
            }
            this.scrollToSection(section);
            e.preventDefault();
        },
    },
    metaInfo: function () {
        if (!this.publishedPropertyBySlug) {
            return {};
        }
        return {
            title: this.publishedPropertyBySlug.metaTitle,
            meta: [
                createMetaDescription(this.publishedPropertyBySlug.metaDescription),
            ],
        };
    },
});
var templateObject_1, templateObject_2;
